interface IconProps {
  size: number;
  color?: string;
}

const Icon = ({ size, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={size}
    fill={color}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2zM20 11H4v8h16v-8zm0-2V7h-8.414l-2-2H4v4h16z"
      fill="#000"
    />
  </svg>
);
export default Icon;
